import { Button, Stack } from '@mui/material';
import { BatchProcessedImageData } from '../types';
import { useMediaLogger } from '../../../media/hooks/useMediaLogger';

export interface EditButtonsActionBarProps {
  onSave?: (batchData: BatchProcessedImageData) => void;
  onGetAllProcessedImages: () => Promise<BatchProcessedImageData>;
  onReset: () => void;
  isResetDisabled?: boolean;
  isSaveDisabled?: boolean;
}

export const EditButtonsActionBar = ({
  onSave,
  onGetAllProcessedImages,
  onReset,
  isResetDisabled = false,
  isSaveDisabled = false,
}: EditButtonsActionBarProps) => {
  const logger = useMediaLogger('EditButtonsActionBar');

  return (
    <Stack direction="row" spacing={2} sx={{ width: '100%', my: 3 }}>
      <Button
        variant="contained"
        color="primary"
        sx={{ flex: 1 }}
        disabled={isSaveDisabled}
        onClick={async () => {
          // Get all processed images that have been edited
          const batchData = await onGetAllProcessedImages();
          logger.log('Batch processed image data:', batchData);

          // Call the onSave callback if provided
          if (onSave && batchData.totalProcessed > 0) {
            onSave(batchData);
          } else if (batchData.totalProcessed === 0) {
            logger.error('No images were edited, nothing to save');
          }
        }}
      >
        SAVE AND EXIT
      </Button>
      <Button
        variant="outlined"
        sx={{ flex: 1 }}
        onClick={onReset}
        disabled={isResetDisabled}
      >
        RESET
      </Button>
    </Stack>
  );
};

export default EditButtonsActionBar;
